/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import {
  convertDataForEnergyDetailSavingsMeter,
  getEnergyColumns,
  getEnergyTotalUsagesMeterDetails,
  getUtilityTypeMeterEnergyDetails
} from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import EmaasDetailBreakdownByMeter from './EmaasDetailBreakdownByMeter';
import { IEnergyData } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  IEnergyBreakdownByMeter,
  ITotalConsumeUtilitydetails
} from './IEnergyUsagesBreakdownProps';
import { ApiContext } from '../../../../context/ApiContext';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: IEnergyData;
}

export const emaasEnergyUsagesAllUtilitySavingsByMeterDetail = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;
  const { energyMeasurementUnit, breakdownByUtility, breakdownByMeter } = data;

  const {
    energyMeterSavingdata,
    utilityUnit
    //conversionUnit
  } = convertDataForEnergyDetailSavingsMeter(breakdownByUtility);
  const energyUtilityTypeMeterDetails = getUtilityTypeMeterEnergyDetails(
    breakdownByMeter,
    utilityUnit,
    fromUnit,
    apiContext.showChangeWhenData
    //conversionUnit
  );
  const totalConsumeUtilitydetails = {
    meterSavingdata: energyMeterSavingdata,
    utilityTypeMeterDetails: energyUtilityTypeMeterDetails
  };

  const Utilitydetails = getEnergyTotalUsagesMeterDetails(
    [(totalConsumeUtilitydetails as unknown) as ITotalConsumeUtilitydetails],
    fromUnit,
    apiContext.showChangeWhenData
  );

  const columnDetails: Array<IDataTableColumn> = getEnergyColumns(
    t,
    data.subscriptionType
  );

  const breakDownByMeterProps = {
    meterData: Utilitydetails,
    utilityMeasurementUnit: energyMeasurementUnit,
    columnDetails,
    energyMeasurementUnit: fromUnit
  } as IEnergyBreakdownByMeter;

  return (
    <div className="emaas-Metersaving-details-head">
      <EmaasDetailBreakdownByMeter {...breakDownByMeterProps} />
    </div>
  );
};
export default memo(emaasEnergyUsagesAllUtilitySavingsByMeterDetail);
